import React from "react";
import Footer from '../Homes/Footer';
import Header from '../Homes/Header';
import '../HomePages/aboutInfytechAI.css'
import { Link } from "react-router-dom";

const AboutInfytechAI = () => {
    return (
        <htm>
            <Header/>
            <body className="main-cont-ab">
            <div><h1>About Infytech AI</h1>
                    <p>Infytech AI provides the right podium to the students who want to succeed in their life.
                        We strongly believe that a good environment is a key factor in developing the right mindset. <strong>"The attitude of a well-raised hyena among lions is better than that of a lion raised among hyenas". </strong> At InfytechAI, we continuously focus on making our students better every day by analyzing their key potential and providing quality education to help them achieve their goals. InfytechAI is not just a name; it is a well-researched and dedicated learning environment for our students.
                        To know more click <Link to="/whyInfytechAI" className="">Why Infytech AI</Link>.</p>
                    <div></div>
                </div>
                <div>At InfytechAI, we are driven by innovation, excellence, and a passion for education. Our dedicated team is committed to provide outstanding services to our clients, ensuring their success and growth. Join us on our journey towards a brighter future through a quality education.</div>
                
            </body>
            <Footer/>
        </htm>
    );
}


export default AboutInfytechAI;